import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { productMap_air_ring_PROD_expanded } from './AIR_PROD';
import { productMap_air_ring_STAGING } from './AIR_STAGING';
import {
  AirRingColors,
  isRingAirSkuDisabled,
  RingSizes,
  RingType,
  type RingVariantType,
} from './enums';

const base =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? productMap_air_ring_PROD_expanded
    : productMap_air_ring_STAGING;

const ALL_STORES = Object.values(ShopifyStore) as ShopifyStore[];

function cloneVariant(variant: RingVariantType): RingVariantType {
  return {
    ...variant,
    variantId: { ...(variant.variantId ?? {}) },
    checkoutUrl: { ...(variant.checkoutUrl ?? {}) },
    misc: variant.misc ? { ...variant.misc } : variant.misc,
  };
}

/**
 * Strip disabled SKUs per store. Empty the matching rule to re-enable.
 * Mutates a clone only — AIR_PROD / AIR_STAGING stay intact.
 */
function omitDisabledSkus(map: typeof base): typeof base {
  const out: typeof base = {};

  for (const [colorKey, sizeMap] of Object.entries(map)) {
    if (!sizeMap) continue;
    const color = colorKey as AirRingColors;
    const keptSizes: NonNullable<(typeof base)[AirRingColors]> = {};

    for (const [sizeKey, typeMap] of Object.entries(sizeMap)) {
      if (!typeMap) continue;
      const size = Number(sizeKey) as RingSizes;
      const keptTypes = {} as Record<RingType, RingVariantType>;

      for (const type of Object.values(RingType) as RingType[]) {
        const variant = typeMap[type];
        if (!variant) continue;
        const cloned = cloneVariant(variant);

        for (const store of ALL_STORES) {
          if (
            isRingAirSkuDisabled({
              color,
              size,
              type,
              store,
            })
          ) {
            delete cloned.variantId[store];
            delete cloned.checkoutUrl[store];
          }
        }

        if (Object.keys(cloned.variantId).length === 0) continue;
        keptTypes[type] = cloned;
      }

      if (Object.keys(keptTypes).length === 0) continue;
      keptSizes[size] = keptTypes as Record<RingType, RingVariantType>;
    }

    if (Object.keys(keptSizes).length === 0) continue;
    out[color] = keptSizes;
  }

  return out;
}

export const productMap_air_ring = omitDisabledSkus(base);
